import makeRequest from './xhr';
import { DOCUMENT_ELEMENT } from '../constants';

export default function showWeather(element) {
  // And we'd call it as such:
  if (!element) return;

  const { lat, lon } = element.dataset;
  const { lang } = DOCUMENT_ELEMENT;

  makeRequest(`https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&APPID=8d3021ef116e429e6bb91256e75f3b0e&units=metric&lang=${lang}`, {
    method: 'GET',
  }, (err, response) => {
    if (err) { throw err; }
    const data = JSON.parse(response);
    const { temp } = data.main;

    const temperature = Math.round(Math.abs(temp));
    // eslint-disable-next-line no-nested-ternary
    const sign = temperature > 0 ? '+' : temperature < 0 ? '-' : '';
    // eslint-disable-next-line prefer-destructuring
    const description = data.weather[0].description;

    $(element).find('[data-role="sign"]').text(sign);
    $(element).find('[data-animation="number"]').text(temperature);
    $(element).find('[data-role="description"]').text(description);
  });
}



// WEBPACK FOOTER //
// ./scripts/utils/weather.js